/**
 * @generated SignedSource<<bce6bb5c57d4150d2947b9acce1b6901>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SplitNoteInput = {
  clientMutationId?: string | null;
  id: string;
  useForNewNotes: boolean;
};
export type NotAOneOnOneSplitMutation$variables = {
  input: SplitNoteInput;
};
export type NotAOneOnOneSplitMutation$data = {
  readonly splitNote: {
    readonly clientMutationId: string | null;
    readonly note: {
      readonly id: string;
    };
    readonly ok: boolean;
  } | null;
};
export type NotAOneOnOneSplitMutation = {
  response: NotAOneOnOneSplitMutation$data;
  variables: NotAOneOnOneSplitMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SplitNotePayload",
    "kind": "LinkedField",
    "name": "splitNote",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Note",
        "kind": "LinkedField",
        "name": "note",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotAOneOnOneSplitMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotAOneOnOneSplitMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0ccb8c9c45a54e391b5f8996ad2d96fd",
    "id": null,
    "metadata": {},
    "name": "NotAOneOnOneSplitMutation",
    "operationKind": "mutation",
    "text": "mutation NotAOneOnOneSplitMutation(\n  $input: SplitNoteInput!\n) {\n  splitNote(input: $input) {\n    clientMutationId\n    ok\n    note {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "02a319b06f92884f0b3af2f16256be14";

export default node;
